import axios from 'axios';
import get from 'lodash/get';
import {
  put,
  call,
  all,
  cancelled,
} from 'redux-saga/effects';
import http from '@api/http';
import * as types from './types';

export default function* autoRequest(func, type, payload, afterRequest, autoCancel = true) {
  yield put({
    type: `${type}${types.SET_PAYLOAD}`,
    payload,
  });
  const source = axios.CancelToken.source();
  try {
    let response = null;
    if (Array.isArray(func) && Array.isArray(payload)) {
      // support multiple query and multiple api
      response = yield all(
        func.map(
          (fn, index) => call(fn, payload[index] || {}, { cancelToken: source.token }, http),
        ),
      );
    } else if (Array.isArray(func) && !Array.isArray(payload)) {
      // support a query and multiple api
      response = yield all(
        func.map(
          fn => call(fn, payload || {}, { cancelToken: source.token }, http),
        ),
      );
    } else if (!Array.isArray(func) && Array.isArray(payload)) {
      // support multiple query and a api
      response = yield all(
        payload.map(
          query => call(func, query || {}, { cancelToken: source.token }, http),
        ),
      );
    } else {
      // support a query and a api
      response = yield call(func, payload, { cancelToken: source.token }, http);
    }
    yield put({
      type: `${type}${types.SET_RESPONSE}`,
      response,
    });
    if (afterRequest) {
      yield call(afterRequest, response);
    }
    yield put({ type: `${type}${types.FETCHING_SUCCESS}` });

    return response;
  } catch (error) {
    yield put({
      type: `${type}${types.FETCHING_FAIL}`,
      errorCode: get(error, 'code', 500),
      errorMsg: get(error, 'response.data.message', 'Unknown Error'),
    });
    throw error;
  } finally {
    if (yield cancelled() && autoCancel) {
      source.cancel();
      yield put({ type: `${type}${types.ABORT_FETCHING}` });
    }
  }
}
